import { render, staticRenderFns } from "./customerdelivery.vue?vue&type=template&id=6c8c29f7"
import script from "./customerdelivery.vue?vue&type=script&lang=js"
export * from "./customerdelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports